import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default class OfferAccessorial extends Component {
    render() {
        const { accessorial: { description, picture_url, }, } = this.props;
        return (React.createElement("div", { className: "offer-accessorial" },
            React.createElement("img", { src: picture_url, alt: description }),
            React.createElement("p", { style: { marginBottom: 3 } },
                React.createElement("small", null, description))));
    }
}
OfferAccessorial.propTypes = {
    accessorial: PropTypes.shape({
        description: PropTypes.string.isRequired,
        picture_url: PropTypes.string.isRequired,
    }).isRequired,
};
